import { ApiGetHook, useApiGet } from "@skanska/vsa-client-auth";
import { useLocation } from "react-router-dom";
import { SearchFilter } from "../models/SearchConfiguration";

export function useGetFilters(
  endpoint: string
): ApiGetHook<Array<SearchFilter>> {
  const location = useLocation();

  return useApiGet<Array<SearchFilter>>(endpoint, null, [
    endpoint,
    location.key,
  ]);
}
